import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";

export function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-navy-900">
      <ScrollToTop />
      <Header />
      {/* pt-16 = match header height so content is not hidden under fixed header */}
      <main className="flex-1 pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
